import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
const SvgFacebook = ({ title, titleId, ...props }, ref)=>/*#__PURE__*/ jsxs("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        role: "img",
        ref: ref,
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ jsx("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ jsx("path", {
                d: "M9.34258 22.6764V15.3614H7.07475V12H9.34258V10.5517C9.34258 6.80708 11.0366 5.07183 14.7124 5.07183C15.08 5.07183 15.5878 5.11033 16.0581 5.16625C16.4103 5.20249 16.7597 5.26221 17.104 5.345V8.39292C16.905 8.37435 16.7053 8.36334 16.5054 8.35992C16.2815 8.3541 16.0575 8.35135 15.8335 8.35167C15.1854 8.35167 14.6794 8.43967 14.2981 8.63492C14.0417 8.76354 13.8262 8.96096 13.6757 9.20508C13.4392 9.59008 13.3328 10.1172 13.3328 10.8111V12H16.9252L16.5714 13.9278L16.3083 15.3614H13.3328V22.9193C18.7797 22.2612 23 17.6238 23 12C23 5.92525 18.0748 1 12 1C5.92525 1 1 5.92525 1 12C1 17.159 4.55117 21.4875 9.34258 22.6764Z",
                fill: "currentColor"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ forwardRef(SvgFacebook);
const Memo = /*#__PURE__*/ memo(ForwardRef);
const Facebook = Memo;
export { Facebook as default };
